import { render, staticRenderFns } from "./IssuuEmbed.vue?vue&type=template&id=fe77e8ba&"
import script from "./IssuuEmbed.vue?vue&type=script&lang=ts&"
export * from "./IssuuEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports